export class MeasurementForm {
  constructor(
    public labelNotes: string,
    public partType: string,
    public width: string,
    public height: string,
    public quantity: number,
    public hingeLocation?: string,
    public cabinetLocation?: string,
    public widthWhole?: number,
    public widthFraction?: string,
    public heightWhole?: number,
    public heightFraction?: string,
    public isFractionMode?: boolean,
  ) {}
}

export class MeasurementFormResult {
  constructor(
    public imageUrl: string,
    public measurementFormList: MeasurementForm[],
  )
  {}
}

export class MeasurementFormPost {
  constructor(
    public apartmentId: number,
    public imageUrl : string,
    public responseJson : string,
    public measurementFormList: Array<MeasurementForm>,
  )
  {}
}
